import React, {FC, SelectHTMLAttributes} from 'react';
import classes from './HLFormSelect.module.scss';

export interface HLFormSelectOption {
    value: string;
    label: string;
}

interface HLFormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    id: string;
    error?: string;
    options: HLFormSelectOption[];
}

const HLFormSelect: FC<HLFormSelectProps> = ({
                                                 id,
                                                 error,
                                                 options,
                                                 children,
                                                 value,
                                                 ...props
                                             }) => {
    return (
        <div className={`${classes.selectGroup} ${error ? classes.error : ''}`}>
            {children && <label className={classes.selectLabel} htmlFor={id}>{children}</label>}
            <select
                className={`${classes.selectField} 
                        ${error ? classes.error : ''} 
                        ${value === '' ? classes.placeholder : ''}`
                }
                id={id}
                value={value}
                {...props}
            >
                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
            </select>
            {error && <div className={classes.errorMessage}>{error}</div>}
        </div>
    );
};

export default HLFormSelect;